import {BREAKPOINTS} from 'utilities/breakpoints';
import {makeImageSourceData} from 'components/UIKit/Picture';

import heroDesktop from './hero-desktop.jpg';
import heroDesktop2x from './hero-desktop2x.jpg';
import heroTablet from './hero-tablet.jpg';
import heroTablet2x from './hero-tablet2x.jpg';
import heroMobile from './hero-mobile.jpg';
import heroMobile2x from './hero-mobile2x.jpg';

export const heroPictureData = {
  sources: [
    makeImageSourceData(heroMobile, heroMobile2x, BREAKPOINTS.mobile),
    makeImageSourceData(heroTablet, heroTablet2x, BREAKPOINTS.tablet),
    makeImageSourceData(heroDesktop, heroDesktop2x, BREAKPOINTS.desktopUp),
  ],
  fallback: heroTablet2x,
};
